/**
 * Telemetria interna. Hoje é stub (loga em DEV, vira no-op em PROD). Quando
 * plugar Sentry/PostHog, substitua só a implementação destes 3 métodos.
 *
 * Por design:
 * - `captureException` recebe um Error + contexto opcional.
 * - `captureMessage` é pra eventos de aviso sem stack trace.
 * - `breadcrumb` é pra trilha de eventos (auth, fetch, navigation) que ajudam
 *    a entender o contexto antes de uma exceção.
 */

import { env } from './env'

const TAG = '[telemetry]'

export const telemetry = {
  captureException(error, context) {
    if (env.IS_DEV) {
      console.error(TAG, error, context ?? '')
    }
    // TODO: Sentry.captureException(error, { extra: context })
  },

  captureMessage(message, context) {
    if (env.IS_DEV) {
      console.warn(TAG, message, context ?? '')
    }
    // TODO: Sentry.captureMessage(message, { extra: context })
  },

  breadcrumb(category, message, data) {
    if (env.IS_DEV) {
      console.debug(TAG, `${category}: ${message}`, data ?? '')
    }
    // TODO: Sentry.addBreadcrumb({ category, message, data, level: 'info' })
  },
}
